module.exports = __webpack_public_path__ + "img/Greg.6be19739.jpg";